export default __webpack_public_path__ + "static/media/Android.992596ef.svg";